import { useQuery } from "react-query";
import axios from "axios";
import { MisAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import { MisQueueSettingsDto } from "../../../types/Mis/MisTypes";

export const useGetMisQueueSettings = (branchQueueId: number | null) => {
  return useQuery(
    ["misQueueSettings", branchQueueId],
    async () => {
      const { data } = await axios.get<MisQueueSettingsDto>(
        MisAPI.getQueueSettings(branchQueueId!),
        commonHeaders(),
      );
      return data;
    },
    { enabled: branchQueueId != null && branchQueueId > 0 },
  );
};
